<ng-container *transloco="let t; read: 'MENU_SELECTION_MODAL'">
  @if (mode === 'calendar') {
    <ion-toolbar>
      <div class="toolbar-header" #toolbar>
        <ion-button (click)="dismissModal()" fill="none" color="secondary">
          <ion-icon slot="icon-only" name="arrow-back-outline"></ion-icon>
        </ion-button>
        <h1>{{ t('TITLE') }}</h1>
        <div class="right"></div>
      </div>
    </ion-toolbar>
  }
  <ion-content [scrollEvents]="true" (ionScroll)="onScroll($event)">
    <div class="menu-selection-container">
      <div #menuContainer class="menu-container" *ngIf="menu.dishFamilies.length > 0; else emptyTpl">
        @let selectableMenu = selectableMenu$ | async;
        <div class="filters" *ngLet="menuFilters$ | async as menuFilters">
          <div class="date mt-12">
            @switch (restaurant.sousType) {
              @case (RestaurantSousTypeValues.Scorp) {
                {{ t('DATE') }} : <span class="capitalize">{{ menu.date | translocoDate: { weekday: 'short' } }}</span>
                {{ menu.pickupLimitDate! | translocoDate: { month: 'long', day: 'numeric' } }}
              }
              @case (RestaurantSousTypeValues.AntiGaspi) {
                {{ t('DATE_PICKUP_BEFORE') }}
                {{ menu.pickupLimitDate! | translocoDate: { timeStyle: 'short' } }}
              }
            }
          </div>

          @if (RestaurantSousTypeValues.AntiGaspi) {
            @for (order of getRestaurantOrdersForToday$() | async; track order.orderId) {
              <app-card class="existing-order-card mt-6 mb-6" (click)="openOrder(order.orderId)">
                <app-card-content>
                  <div class="flex-1">
                    <div class="flex items-center mt-4 existing-order-title">
                      {{ t('ORDER') }} nº{{ order.orderId }}
                      <div>&nbsp;·&nbsp;{{ 'RestaurantServiceValues.' + order.service | transloco }}</div>
                    </div>
                    <div class="flex items-center mt-8">
                      <div class="spacer"></div>
                      <div class="font-semibold mx-8">{{ t('SEE_ORDER') }}</div>
                      <ion-icon name="chevron-forward-outline"> </ion-icon>
                    </div>
                  </div>
                </app-card-content>
              </app-card>
            }
          }

          @if (!selectableMenu?.displaySettings?.hideDishFamilyFilters) {
            <div class="divider mt-12"></div>
            <app-menu-category
              class="mt-16 mb-12"
              [categories]="menuFilters.categories"
              [category]="menuFilters.currentCategory"
              (categoryChange)="onSelectCategory($event)"
              (openOptions)="onOpenOptions()"
            >
            </app-menu-category>
          } @else {
            <div class="divider mt-12 mb-24"></div>
          }
        </div>

        <div class="families fade-in" *ngIf="selectableMenu">
          <!-- Formules -->
          <div class="family" *ngIf="selectableMenu.formulas && selectableMenu.formulas.length > 0">
            <h3 class="list-category mt-24">Formules</h3>

            <div class="card-compact-list grid-desktop" *ngLet="formulaCountInCart(selectableMenu.formulas) as formulaCountInCart">
              <app-formula-card
                *ngFor="let formula of selectableMenu.formulas; trackBy: trackById"
                [class.selected]="!!formula.selectable.amountInCart && formulaCountInCart"
                [formula]="formula"
                [canAddFormula]="formulaCountInCart < (menu.maxFormulasAllowed ?? 1)"
                (add)="openFormulaModal(formula, restaurantId, menuDate)"
              >
                {{ formula.label }}
              </app-formula-card>
            </div>
          </div>

          @if (selectableMenu.organized) {
            @for (dishFamily of selectableMenu.organized; track $index; let i = $index) {
              <div class="family">
                @if (!selectableMenu?.displaySettings?.hideDishFamilyFilters) {
                  <h3 class="list-category mt-24">{{ dishFamily.label }}</h3>
                }

                <div class="card-compact-list grid-desktop">
                  <app-dish-card
                    *ngFor="let dish of dishFamily.dishes; let j = index; trackBy: trackById"
                    [dish]="dish"
                    [dishInformation]="currentDishInformation$ | async"
                    [userAllergens]="userAllergens"
                    [focusAddButton]="isFocused(i, j)"
                    [forceDisabledAddButton]="dishFamily.isMaxItemsReached"
                    [class.selected]="!!dish.selectable?.amountInCart"
                    (click)="onDishCardClick(dish)"
                    (add)="addDishToCart(dish, i, j)"
                    (remove)="removeDishFromCart(dish)"
                    (focusQuantity)="focusDish(i, j)"
                    [showDescription]="selectableMenu?.displaySettings?.showDescription"
                  >
                  </app-dish-card>
                </div>
              </div>
            }
          } @else {
            <!-- Loop Dish family -->
            <div *ngFor="let dishFamily of selectableMenu.dishFamilies; let i = index; trackBy: trackByLabel">
              <div *ngIf="dishFamily.dishesByComposantesMenus && dishFamily.dishesByComposantesMenus.length > 0">
                <div class="family" *ngFor="let subDishFamily of dishFamily.dishesByComposantesMenus; trackBy: trackByLabel">
                  @if (!selectableMenu?.displaySettings?.hideDishFamilyFilters) {
                    <h3 class="list-category mt-24" *ngIf="subDishFamily.label">{{ subDishFamily.label }}</h3>
                    <h3 class="list-category mt-24" *ngIf="!subDishFamily.label">{{ dishFamily.label }}</h3>
                  }

                  <div class="card-compact-list grid-desktop">
                    <app-dish-card
                      *ngFor="let dish of subDishFamily.dishes; let j = index; trackBy: trackById"
                      [dish]="dish"
                      [dishInformation]="currentDishInformation$ | async"
                      [userAllergens]="userAllergens"
                      [focusAddButton]="isFocused(i, j)"
                      [forceDisabledAddButton]="dishFamily.isMaxItemsReached"
                      [class.selected]="!!dish.selectable?.amountInCart"
                      (click)="onDishCardClick(dish)"
                      (add)="addDishToCart(dish, i, j)"
                      (remove)="removeDishFromCart(dish)"
                      (focusQuantity)="focusDish(i, j)"
                      [showDescription]="selectableMenu?.displaySettings?.showDescription"
                    >
                    </app-dish-card>
                  </div>
                </div>
              </div>

              <div class="family" *ngIf="!dishFamily.dishesByComposantesMenus || dishFamily.dishesByComposantesMenus.length === 0">
                @if (!selectableMenu?.displaySettings?.hideDishFamilyFilters) {
                  <h3 class="list-category mt-24">{{ dishFamily.label }}</h3>
                }

                <div class="card-compact-list grid-desktop">
                  <app-dish-card
                    *ngFor="let dish of dishFamily.dishes; let j = index; trackBy: trackById"
                    [dish]="dish"
                    [dishInformation]="currentDishInformation$ | async"
                    [userAllergens]="userAllergens"
                    [focusAddButton]="isFocused(i, j)"
                    [forceDisabledAddButton]="dishFamily.isMaxItemsReached"
                    [class.selected]="!!dish.selectable?.amountInCart"
                    (click)="onDishCardClick(dish)"
                    (add)="addDishToCart(dish, i, j)"
                    (remove)="removeDishFromCart(dish)"
                    (focusQuantity)="focusDish(i, j)"
                    [showDescription]="selectableMenu?.displaySettings?.showDescription"
                  >
                  </app-dish-card>
                </div>
              </div>
            </div>
          }
        </div>
      </div>

      <ng-template #emptyTpl class="text-center mt-16">
        {{ t('NO_DISH') }}
      </ng-template>
    </div>
    <div class="cart-button-container" *ngIf="isCartFilled$ | async" (click)="openCartModal()">
      <app-cart-button></app-cart-button>
    </div>
  </ion-content>
</ng-container>
